import connectAsync from '../../../utils/connectAsync';
import fetchPartner from '../../../utils/connectors/fetchPartner';
import fetchProducts from '../../../utils/connectors/fetchProducts';
import OauthAuthRoute from './OauthAuthRoute';
import { unauthenticateUser } from './../../../actions/auth';

export default connectAsync([
  fetchPartner,
  ({ location }) => fetchProducts(location),
  unauthenticateUser,
])(OauthAuthRoute);
